import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 小数制限, 日付書式} from '@/type/validation/validator';

export interface 棚卸部署型 {
    部署コード: string;
    部署名: string;
}

export interface 棚卸部署概要型 {
  部署コード: string;
  部署名: string;
  最新棚卸日付: Date;
  未確定棚卸日付: Date;
}

export enum 棚名有無区分型 {
  空白のみ = '空白のみ',
  空白以外のみ = '空白以外のみ',
}

export enum 理論在庫有無区分型 {
  在庫ありのみ = '在庫ありのみ',
  在庫なしのみ = '在庫なしのみ',
  マイナス在庫のみ = 'マイナス在庫のみ',
}

export enum 使用区分型 {
  その他 = 'その他',
  内服薬 = '内服薬',
  注射薬 = '注射薬',
  外用薬 = '外用薬',
  歯科用薬 = '歯科用薬',
}

export enum 並順区分型 {
  棚名棚番号 = '棚名棚番号',
  商品名カナ = '商品名カナ',
  メーカー名カナ = 'メーカー名カナ',
  有効期限 = '有効期限',
  理論在庫金額 = '理論在庫金額',
}

export class 棚卸検索条件型 {
  constructor(public 在庫場所: string = '',
              public 棚卸年月日: Date | null = null,
              public 棚名検索条件: string = '',
              public 棚番号検索条件: string = '',
              public 棚名有無検索条件: 棚名有無区分型 | null = null,
              public 理論在庫有無検索条件: 理論在庫有無区分型 | null = null,
              public 使用区分検索条件: 使用区分型 | null = null,
              public メーカー名検索条件: string = '',
              public 商品名カナ検索条件: string = '',
              public 並順区分検索条件: 並順区分型 = 並順区分型.棚名棚番号,
  ) {}

  public 絞込み条件のクリア() {
    this.棚名検索条件 = '';
    this.棚番号検索条件 = '';
    this.棚名有無検索条件 = null;
    this.理論在庫有無検索条件 = null;
    this.使用区分検索条件 = null;
    this.商品名カナ検索条件 = '';
    this.メーカー名検索条件 = '';
    this.並順区分検索条件 = 並順区分型.棚名棚番号;
  }
}

export interface 棚卸取得依頼型 {
  部署コード: string;
  棚卸年月日: string;
}

export interface 棚卸絞込み依頼型 {
  部署コード: string;
  棚卸年月日: string;
  棚名検索条件: string;
  棚番号検索条件: string;
  棚名有無検索条件: 棚名有無区分型 | null;
  理論在庫有無検索条件: 理論在庫有無区分型 | null;
  使用区分検索条件: 使用区分型 | null;
  商品名カナ検索条件: string;
  メーカー名検索条件: string;
  並順区分検索条件: 並順区分型;
}

export interface 棚卸情報型 {
    ヘッダー: 棚卸ヘッダー型;
    明細一覧: 棚卸明細型[];
    有効期限あり明細一覧: 棚卸明細型[];
}

export interface 棚卸ヘッダー型 {
    棚卸番号: number;
    部署コード: string;
    棚卸日付: Date;
    確定状態: string;
}

export interface 棚卸明細型 {
    棚卸商品: 棚卸商品型;
    棚卸在庫: 棚卸在庫型;
    棚番設定: 棚番設定型;
    在庫金額: 在庫金額型;
    更新バージョン: number;
}

export interface 棚卸商品型 {
    商品コード: string;
    メーカー名: string;
    商品名: string;
    規格容量: string;
    入数: number;
    単位: string;
    バラ単位区分: バラ単位区分型;
    包装単位数: number;
    包装数量数: number;
}

export enum バラ単位区分型 {
    包装単位 = '包装単位',
    包装数量 = '包装数量',
}

export enum 在庫区分型 {
  通常 = '通常',
  譲受 = '譲受',
}

export interface 棚卸在庫型 {
    有効期限: Date;
    在庫区分: 在庫区分型;
    マイナス理論在庫: 理論在庫型;
    理論在庫: 理論在庫型;
    実在庫: 実在庫型;
    差数: number;
}

export interface 棚番設定型 {
    棚番リビジョン番号: number;
    棚名: string;
    棚番号: string;
}

export interface 理論在庫型 {
    箱数: number;
    バラ数: number;
    在庫換算数: number;
}

export interface 実在庫型 {
    箱数: number;
    バラ数: number;
    在庫換算数: number;
}

export interface 在庫金額型 {
    納入単価: number|null;
    理論在庫: number|null;
    実在庫: number|null;
}

export interface 棚卸作成依頼型 {
    部署コード: string;
    棚卸年月日: string;
}

export interface 棚卸保存依頼型 {
    棚卸番号: number;
    部署コード: string;
    棚卸日付: string;
    棚卸明細: 棚卸明細行保存依頼型[];
    有効期限あり棚卸明細: 有効期限あり棚卸明細行型[];
}

export interface 棚卸明細行保存依頼型 {
    商品コード: string;
    有効期限: string;
    在庫区分: 在庫区分型;
    棚名: string;
    棚番号: string;
    箱数: number;
    バラ数: number;
    更新バージョン: number;
    理論在庫換算数: number;
    実在庫換算数: number|null;
}

export interface 有効期限あり棚卸明細行型 {
    商品コード: string;
    有効期限: string;
    在庫区分: 在庫区分型;
    棚名: string;
    棚番号: string;
    理論在庫換算数: number;
    更新バージョン: number;
}

export interface 棚卸確定依頼型 {
    棚卸明細: 棚卸明細行確定依頼型[];
    有効期限あり棚卸明細: 有効期限あり棚卸明細行型[];
}

export interface 棚卸明細行確定依頼型 {
    商品コード: string;
    有効期限: string;
    在庫区分: 在庫区分型;
    棚名: string;
    棚番号: string;
    箱数: number;
    バラ数: number;
    更新バージョン: number;
    理論在庫換算数: number;
    実在庫換算数: number|null;
}

export interface 棚卸再計算依頼型 {
  棚卸明細: 棚卸明細行再計算依頼型[];
  有効期限あり棚卸明細: 有効期限あり棚卸明細行型[];
}

export interface 棚卸明細行再計算依頼型 {
  商品コード: string;
  有効期限: string;
  在庫区分: 在庫区分型;
  棚名: string;
  棚番号: string;
  箱数: number;
  バラ数: number;
  更新バージョン: number;
  理論在庫換算数: number;
  実在庫換算数: number|null;
}

export interface ハンディ棚卸情報型 {
  取込可能件数: number;
}

export interface 棚卸部署確定取消候補型 {
  棚卸番号: number;
  部署コード: string;
  部署名: string;
  棚卸日付: Date;
  確定状態: string;
}


function 棚卸年月日は入力必須(value: string): boolean {
  if (value) {
    return true;
  }
  return false;
}

function 入力必須(value: any): boolean {
  return typeof value === 'number';
}

function 実在庫数は0以上(value: number): boolean {
  if (入力必須(value) === false) {
    return true;
  }

  return 0 <= value;
}

export const 棚卸検索条件バリデータ一覧: Validator[] = [
  {
    name: '棚卸年月日',
    constraints: [
      {method: 棚卸年月日は入力必須, message: '棚卸年月日は入力必須項目です'},
      {method: 日付書式, message: '棚卸年月日の書式が不正です'},
    ],
  },
];

export const 棚卸絞込条件バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ検索条件',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
];

export const 棚卸入力バリデータ一覧: Validator[] = [
  {
    name: '棚卸在庫.実在庫.箱数',
    constraints: [
      {method: 入力必須, message: '実在庫(箱)を入力してください'},
      {method: 実在庫数は0以上, message: '実在庫(箱)は0以上を入力してください'},
      {method: (value) => 小数制限(value, 9, 0), message: '実在庫(箱)は整数部9桁以内で入力してください'},
    ],
  },
  {
    name: '棚卸在庫.実在庫.バラ数',
    constraints: [
      {method: 入力必須, message: '実在庫(バラ)を入力してください'},
      {method: 実在庫数は0以上, message: '実在庫(バラ)は0以上を入力してください'},
      {method: (value) => 小数制限(value, 9, 3), message: '実在庫(バラ)は整数部9桁以内かつ小数以下3桁以内で入力してください'},
    ],
  },
];
